var AuthFormLogin = ( function($) {

    var AuthFormLogin = function(options) {
        this.init(options);
    };

    var Self = AuthFormLogin;
    Self.className = 'AuthFormLogin';
    var Parent = ActionformAbstract;

    var def = ActionformAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);

        if (that.$onetime_mode_switch_checkbox.length) {
            that.__setOnetimePasswordMode(that.$onetime_mode_switch_checkbox.prop('checked'));
        }
    };

    Self.prototype.initVars = function (options) {
        var that = this;

        options = options || {};

        that.selectors = {
            form: '.js-form-login',
            next_action: '.js-form-login-onetime-password-perform', // only if onetime password mode is turned on
            previous_action: '',

            onetime_mode_switch_checkbox: '.js-onetime-mode-switch-checkbox',
            password_field: '.js-password-field',

            next_action_sent_to: '.js-sent-to',
            next_action_sent_info: '.js-info-alert',
            next_action_login_input: '.js-login',
            next_action_code_request_timelimit: '.js-request-code-timelimit',
        };

        that.data_keys = {
            next_action_next_code_time_limit: 'time-limit',
        };

        that.default_login_url = $.sa.build_url('auth/login');
        that.onetime_password_login_url = $.sa.build_url('auth/login-onetime-password');

        that.url = that.default_login_url;
        that.method = 'POST';

        that.next_url = def(options.next_url, ''); // reload current page by default
        that.has_success_screen = false;

        // to save data in the local storage, when not in modal mode (next action is separate page e.g.)
        that.next_action_data_key_prefix = 'avia/auth-login-onetime-pwd-';

        that.is_onetime_password_mode = def(options.is_onetime_password_mode, false);

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initDomElements = function () {
        var that = this;

        Parent.prototype.initDomElements.call(that);

        that.$onetime_mode_switch_checkbox = that.$form_wrapper.find(that.selectors.onetime_mode_switch_checkbox);
        that.$password_field = that.$form_wrapper.find(that.selectors.password_field);
    };

    Self.prototype.initNextAction = function ($action) {
        var that = this;

        Parent.prototype.initNextAction.call(that, $action);

        that.$next_action_sent_to = that.$next_action.find(that.selectors.next_action_sent_to);
        that.$next_action_sent_info = that.$next_action.find(that.selectors.next_action_sent_info);
        that.$next_action_login_input = that.$next_action.find(that.selectors.next_action_login_input);
        that.$next_action_code_request_timelimit = that.$next_action.find(that.selectors.next_action_code_request_timelimit);
    };

    Self.prototype.initEventHandlers = function () {
        var that = this;

        Parent.prototype.initEventHandlers.call(that);

        that.$onetime_mode_switch_checkbox.on('change', function (e) {
            var $checkbox = $(this),
                value = $checkbox.prop('checked');

            that.__onChangeOnetimePasswordMode(value);
        });
    };

    // on show - clear everything except of input values
    Self.prototype.onActionShown = function () {
        var that = this,
            $form_inputs = that.getFormInputs().find('input');

        // clear errors
        that.clearErrors();
        // enable all inputs
        UIInput.prototype.enable($form_inputs);
        // enable submit button
        that.toggleSubmitButtonAvailability(true);
    };

    Self.prototype.beforeMoveToNextAction = function (response) {
        var that = this,
            data = (response && response.data) || {};

        // set `sent_to`, `login` and `next_code_time` values
        // (in modal mode it should be made after next action was shown)
        that.__saveNextActionData(data);
    };

    Self.prototype.showErrors = function (errors) {
        errors = errors || [];

        var that = this,
            // "out of limit code requests" error
            request_limit_error_index = errors.findIndex(er => er.code == 1104), // if someday we won't need to display that error, we could delete that error from the `errors` by index
            login_blocked_error_index = errors.findIndex(er => er.code == 1102);

        if (-1 !== request_limit_error_index || -1 !== login_blocked_error_index) {
            that.toggleSubmitButtonAvailability(false);
            // if someday we won't need to display that error, uncomment next line, and remove previous line
            // errors.splice(request_limit_error_index, 1);
        }
        Parent.prototype.showErrors.call(that, errors);
    };

    Self.prototype.isRedirectResponse = function (response) {
        var that = this;
        // redirect url only if `redirect_url` is set in the response data, or in non-onetime-password mode
        return (that.getRedirectUrlFromResponse(response) !== null || !that.isOnetimePasswordMode());
    };

    Self.prototype.needRedirect = function () {
        var that = this;

        // in non-onetime-password mode - always redirect (or reload page)
        return !that.isOnetimePasswordMode();
    };
    
    Self.prototype.needGoToNext = function () {
        var that = this;

        // in onetime-password mode - always move to the next screen, even in non-modal mode
        return that.isOnetimePasswordMode();
    }

    Self.prototype.isOnetimePasswordMode = function () {
        var that = this;
        
        return that.is_onetime_password_mode;
    };

    Self.prototype.__onChangeOnetimePasswordMode = function (value) {
        var that = this;

        that.__setOnetimePasswordMode(value);
    };

    Self.prototype.__setOnetimePasswordMode = function (value) {
        var that = this;

        if (value) {
            that.__enableOnetimePasswordMode();
        } else {
            that.__disableOnetimePasswordMode();
        }
    };

    Self.prototype.__enableOnetimePasswordMode = function () {
        var that = this;

        that.is_onetime_password_mode = true;
        that.url = that.onetime_password_login_url;

        that.$password_field.hide();
        that.$form_button_submit.text(that.getLocalePhrase('request_code'));
    };

    Self.prototype.__disableOnetimePasswordMode = function () {
        var that = this;

        that.is_onetime_password_mode = false;
        that.url = that.default_login_url;

        that.$password_field.show();
        that.$form_button_submit.text(that.getLocalePhrase('sign_in'));
    };

    Self.prototype.__saveNextActionData = function (data) {
        var that = this;

        if (that.needGoToNext()) {
            that.__saveNextActionDataModalMode(data);
        }
        else {
            that.__saveNextActionDataNotModalMode(data);
        }
    };

    Self.prototype.__saveNextActionDataModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            login_type = data.type || 'unknown',
            next_code_time = data.next_code_time || 0;

        // in modal mode, save values into DOM elements
        that.$next_action_sent_to.text(
            that.getLocalePhrase('sent_to.' + login_type, that.getLocalePhrase('sent_to.unknown')) + ' ' + sent_to
        );
        that.$next_action_sent_info.text(
            that.getLocalePhrase('sent_info.' + login_type, that.getLocalePhrase('sent_info.unknown'))
        );
        that.$next_action_login_input.val(login);
        that.$next_action_code_request_timelimit
            .attr('data-' + that.data_keys.next_action_next_code_time_limit, next_code_time);
    };

    Self.prototype.__saveNextActionDataNotModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            login_type = data.type || 'unknown',
            next_code_time = data.next_code_time || 0,
            key_prefix = that.next_action_data_key_prefix + '-';

        // not in modal mode (if next action is on separate page e.g.), save data into local storage
        sessionStorage.setItem(key_prefix + 'login', login);
        sessionStorage.setItem(key_prefix + 'login-type', login_type);
        sessionStorage.setItem(key_prefix + 'sent-to', sent_to);
        sessionStorage.setItem(key_prefix + 'next-request-timelimit', next_code_time);
    };

    return Self;
})(jQuery);